<div class="text-center py-2" *ngIf="viewContainer==false && !field.hidden">
    
    <button (click)="viewContainerFunc()" class="btn btn-primary">
      {{ 'view' | translate }} {{field.label}}
    </button>
</div>


<div class="text-center py-2" *ngIf="viewContainer==true && field.required==false && !field.hidden">
    
    <button (click)="hideContainerFunc()" class="btn btn-primary">
       {{ 'hide' | translate }} {{field.label}} 
    </button>
</div>

<div *ngIf="!field.hidden && viewContainer" [formGroup]="myForm!">

    <div class=" card px-2" *ngIf="field.designType!='TABLE'">
        <div class=" row">
            <div class="col-md-12 col-12">
                <div class="solution_card">

                    <h4 class="text-center mt-2">{{field.label}}</h4>

                    <div>
                        <ng-container *ngFor="let container of containerItems;let i=index">

                            <div class="col-12"
                                style="text-align: left;"
                                *ngIf="i>0 && field.modifiable && viewApplication==false">
                                <i role="button"
                                    (click)="deleteContainer(container.id,container.containerId)"
                                    class="fa-solid fa-trash text-danger p-2"
                                    style="padding: 7px;border: 2px solid #eee;border-radius: 5px;"></i>
                            </div>

                            <ng-container *ngFor="let containerFiled of container.containerFields">


                                
                                <ng-container *ngIf="containerFiled.type=='CONTAINER'">

                                    <app-container
                                    [containerItems]="GetContainerItems(containerFiled.id)"
                                    [submitted]="submitted"
                                    [fieldId]="containerFiled.id"
                                    [field]="containerFiled"
                                    [yourTurn]="yourTurn"
                                    [viewApplication]="viewApplication"
                                    [myForm]="myForm"
                                    [phoneDto]="phoneDto"
                                    [files]="getFiles(containerFiled.id)"
                                    (deleteContainerEvent)="deleteContainer(container.index,containerFiled.id)"
                                    (addContainerItemsEvent)="addContainerItems(containerFiled)"
                                    (refreshFormEvent)="refreshForm($event)"
                                    (getFormControlErrorsEvent)="getFormControlErrors($event)">
                                    </app-container>

                                    <br>

                                </ng-container>


                                <ng-container
                                    *ngIf="containerFiled.type=='TEXT_FIELD_PHONE'">

                                    <app-text-field-phone
                                        [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        [yourTurn]="yourTurn"
                                        [isContainer]="true"
                                        [phoneNumber]="phoneDto"
                                        [viewApp]="viewApplication!"
                                        [containerFieldId]="field.id" [fieldIndex]="i"
                                        (refreshFormEvent)="refreshForm($event)"></app-text-field-phone>


                                </ng-container>

                                
                                <ng-container
                                    *ngIf="containerFiled.type=='TEXT_FIELD'">

                                <app-text-field [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        [hidden]="containerFiled.hidden"
                                        [calculationFields]="calculationField"
                                        [yourTurn]="yourTurn"
                                        [isContainer]="true"
                                        [containerFieldId]="field.id" [fieldIndex]="i"
                                        (refreshFormEvent)="refreshForm($event)"
                                        (calulcateTextField)="calculate($event)"
                                        >
                                    </app-text-field>
                                </ng-container>
                                

                              

                                
                                <ng-container
                                    *ngIf="containerFiled.type=='DATE'">

                                    <app-date [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        [value]="myForm?.get(containerFiled.id)?.value"
                                        [yourTurn]="yourTurn"
                                        [isContainer]="true"
                                        [containerFieldId]="field.id" [fieldIndex]="i"
                                        (refreshFormEvent)="refreshForm($event)"></app-date>
                                </ng-container>

                                <ng-container
                                    *ngIf="containerFiled.type=='CHECKBOX'">

                                    <app-checkbox [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        [yourTurn]="yourTurn"
                                        [isContainer]="true"
                                        [containerFieldId]="field.id" [fieldIndex]="i"
                                        (refreshFormEvent)="refreshForm($event)"></app-checkbox>

                                </ng-container>


                                <ng-container
                                    *ngIf="containerFiled.type=='COMBO_BOX'">


                                    <app-combo-box [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        [yourTurn]="yourTurn"
                                        [isContainer]="true"
                                        [containerFieldId]="field.id" [fieldIndex]="i"
                                        (refreshFormEvent)="refreshForm($event)"></app-combo-box>

                                </ng-container>

                                <ng-container *ngIf="containerFiled.type=='MULTI_COMBO_BOX'">


                                    <app-multi-select [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        [yourTurn]="yourTurn"
                                        [isContainer]="true"
                                        [containerFieldId]="field.id" [fieldIndex]="i"
                                        (refreshFormEvent)="refreshForm($event)"></app-multi-select>

                                </ng-container>

                                <ng-container *ngIf="containerFiled.type=='MULTI_PREDEFINED_COMBO_BOX'">


                                    <app-predfiend-multi-select [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        [yourTurn]="yourTurn"
                                        [isContainer]="true"
                                        [containerFieldId]="field.id" [fieldIndex]="i"
                                        (refreshFormEvent)="refreshForm($event)"></app-predfiend-multi-select>

                                </ng-container>

                                <ng-container
                                    *ngIf="containerFiled.type=='FILE'">

                                    <app-file 
                                        [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [viewApplication]="viewApplication!"
                                        [files]="getFiles(containerFiled.id)"
                                        [isInvalid]="getFiles(containerFiled.id).length==0 && containerFiled.required"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        [yourTurn]="yourTurn"
                                        [containerFieldId]="field.id" 
                                        [fieldIndex]="i"
                                        [isContainer]="true"
                                        (refreshFormEvent)="refreshForm($event)"
                                        (onUploadFileEvent)="onUploadFile($event)"
                                        (deleteFileEvent)="deleteFile($event)"
                                        >
                                    </app-file>

                                </ng-container>

                                <ng-container
                                    *ngIf="containerFiled.type=='TEXT_VIEW'">

                                    <app-text-view
                                    [formGroup]="myForm!"
                                    [errors]="getFormControlErrors(containerFiled.id)"
                                    [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                    [field]="containerFiled"
                                    [hidden]="containerFiled.hidden"
                                    [value]="myForm?.get(containerFiled.id)?.value"
                                    [fieldId]="containerFiled.id"
                                    [submitted]="submitted"
                                    [yourTurn]="yourTurn"
                                    [containerFieldId]="field.id" [fieldIndex]="i"
                                    (refreshFormEvent)="refreshForm($event)"></app-text-view>


                                </ng-container>

                                <ng-container
                                    *ngIf="containerFiled.type=='PREDEFINED_COMBO_BOX'">


                                    <app-predefined-combo-box
                                        [formGroup]="myForm!"
                                        [errors]="getFormControlErrors(containerFiled.id)"
                                        [isInvalid]="!myForm?.get(containerFiled.id)?.valid!"
                                        [field]="containerFiled"
                                        [fieldId]="containerFiled.id"
                                        [submitted]="submitted"
                                        
                                        [yourTurn]="yourTurn"
                                        
                                        [isContainer]="true"
                                        [containerFieldId]="field.id" [fieldIndex]="i"
                                        (refreshFormEvent)="refreshForm($event)"></app-predefined-combo-box>


                                </ng-container>

                            </ng-container>

                            <hr
                                *ngIf="containerItems.length>1">

                        </ng-container>


                        <div class="col-12 text-center py-3"
                            *ngIf="field.modifiable==true && !viewApplication"  >
                            <button id="submit-button"
                                class="btn btn-primary"
                                (click)="addContainerItems(field)">{{'Add'|translate}}</button>
                        </div>

                    </div>

                 
                </div>

            </div>
        </div>
        
    </div>

    
    <p class="pt-1 text-danger" style="font-size: 13px !important;" *ngIf="yourTurn && field?.approved == false">
        {{field.comment}}
    </p>

    <div *ngIf="field.designType=='TABLE'">

        <div style="text-align: center;"> 
            <h5>
                {{field.label}}
            </h5>
        </div>

        <table class="table text-center my-3">
            <thead class="thead-light">

                <tr>
                    <th *ngFor="let containerTableHeader of field.fields">
                        {{containerTableHeader.label}} </th>
                    </tr>

            </thead>

            <tbody *ngIf="field.value.length>0">

                <tr *ngFor="let containerTableBody of field.value ;let i =index">
                    <td *ngFor="let containerTableHeader of field.fields">
                        {{getContainerTableValue(field.value,containerTableHeader.id,i)}}
                    </td>
                </tr>


                <!-- <tr *ngFor="let containerTableBody of field.value">

                    <td *ngFor="let containerTableBodyValue of containerTableBody">
                        {{getContainerTableValue(containerTableBody,containerTableBodyValue.fieldId)}}
                    </td>

                </tr> -->

            </tbody>
        </table>
    </div>

</div>